module.exports = __webpack_public_path__ + "img/vertical_7_6_6005.6c33b469.png";